module.exports = __webpack_public_path__ + "static/img/273_TO8_2391.b8b1b88.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/273_TO8_2391.jpg
// module id = Sbw4
// module chunks = 0